import { Model } from 'vue-models'
import Company from './company'

export default class User extends Model {
  static defaults () {
    return {
      name: 'user',
      basePath: 'rest-auth/user',
      computed: {
        __str__ () { return this.short_name }
      }
    }
  }
  static schema () {
    return {
      userprofile: {
        type: Object,
        properties: {
          company: { type: Company },
          report_emails: { type: Array, items: { type: String } },
          attention_required_event_codes: { type: Array, items: { type: Number } },

          days_of_delay: { type: Object },
          days_in_advance: { type: Object },

          max_days_in_tsp: { type: Object },
          max_days_in_pol: { type: Object },
          max_days_in_pod: { type: Object },

          max_storage_days_at_pod: { type: Object },
          max_storage_days_at_pol: { type: Object },

          max_days_between_empty_return_and_pod: { type: Object },
          max_days_between_empty_return_and_lif: { type: Object },

          max_days_in_tsp_planned: { type: Object },
          max_days_in_pol_planned: { type: Object },
          max_days_in_pod_planned: { type: Object },

          max_storage_days_at_pod_planned: { type: Object },
          max_storage_days_at_pol_planned: { type: Object },

          max_days_between_empty_return_and_pod_planned: { type: Object },
          max_days_between_empty_return_and_lif_planned: { type: Object },

          max_days_eta_pod_discrepancy: { type: Object },
          max_days_eta_dlv_discrepancy: { type: Object },

          pod_timeofarrival_warning_risk: { type: Object },

          email_report_attention_required_event_codes: { type: Array, items: { type: Number } },

          email_report_days_of_delay: { type: Object },
          email_report_days_in_advance: { type: Object },

          email_report_max_days_in_tsp: { type: Object },
          email_report_max_days_in_pol: { type: Object },
          email_report_max_days_in_pod: { type: Object },

          email_report_max_storage_days_at_pod: { type: Object },
          email_report_max_storage_days_at_pol: { type: Object },

          email_report_max_days_in_tsp_planned: { type: Object },
          email_report_max_days_in_pol_planned: { type: Object },
          email_report_max_days_in_pod_planned: { type: Object },

          email_report_max_storage_days_at_pod_planned: { type: Object },
          email_report_max_storage_days_at_pol_planned: { type: Object },

          email_report_max_days_between_empty_return_and_pod_planned: { type: Object },
          email_report_max_days_between_empty_return_and_lif_planned: { type: Object },

          email_report_max_days_eta_pod_discrepancy: { type: Object },
          email_report_max_days_eta_dlv_discrepancy: { type: Object },

          email_pod_timeofarrival_warning_risk: { type: Object },

          role: { type: Object },
          is_manager: { type: Object },
          trackings_fields: { type: Object },
          shipments_fields: { type: Object }
        }
      },
      is_superuser: { type: Object },
      id: { type: Object },
      first_name: { type: Object },
      last_name: { type: Object },
      username: { type: Object },
      email: { type: Object }
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/user.js